<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Location from '$lib/PageSections/OurLocation/OurLocation.svelte';

	import clearClip from './images/clearClip.jpg';
	import drill from './images/drill.jpg';
	import measure from './images/measure.jpg';
	import retainingPins from './images/retainingPins.png';
	import safetyBrackets from './images/safetyBrackets.jpg';
</script>

<Section backgroundColor="white">
	<p>
		We have a <a href="/about-indow/care/installation-resources"
			>customer resource page</a
		> full of advice on measuring, installing, or caring for your insert. Visit any
		time you have an issue.
	</p>
	<p>
		Window inserts offer many great benefits from insulation to noise reduction,
		but if they aren’t safely installed, they can become a hazard. This page
		will walk you through proper window insert installation including adding
		safety hardware for large or shallow installs.
	</p>
</Section>

<Section>
	<h2>Safety Brackets</h2>
	<p>
		Brackets are used for larger inserts to keep people and objects safe in the
		event the insert falls out of the window. This is unlikely, but we’d rather
		be safe. Please <a href="/about-indow/how-to-order/measure"
			>follow our installation guide</a
		> for full details on installing your Indow inserts. The instructions below are
		if you are installing the safety brackets after your inserts have already been
		installed. If your insert did not come with the safety chains attached (due to
		size or shape), this will not apply.
	</p>

	<Image src={safetyBrackets} />

	<h3>Install hardware in your window frame.</h3>
	<p>Brackets are installed inside the window frame on each side.</p>

	<p>
		Measure distance indicated on product label (or the location mailed to you)
		up from bottom of window frame. Mark with pencil. Bracket will sit behind
		insert so it is hidden from view. If you do not have the location, you can
		easily visually line up the end of the chains with your window frame.
		Measure the distance for each size to ensure consistency.
	</p>

	<Image src={measure} />

	<p>
		Drill a small hole (we suggest 1/16”). Use provided screws to install
		brackets.
	</p>

	<Image src={drill} />

	<h3>Insert the insert.</h3>
	<p>
		Place bottom of insert on window sill and within the indicated frame step
		(centered, with the same amount over the window frame on right & left).
		Gently push bottom of insert into place. Make sure the bottom corners are
		evenly compressed.
	</p>
	<h3>Attach safety chain.</h3>
	<p>
		Reach around both sides of the insert to place last ball of the chain into
		the bracket.
	</p>
</Section>

<Section>
	<h2>How to Install Swivel Clips</h2>
	<p>
		Swivel clips are clear plastic clips attached to your window frame with a
		single screw. They turn to affix your Indow insert in place. Insert must be
		flush with your window trim for this accessory to work.
	</p>

	<Image src={clearClip} class="w-auto" />

	<h3>Pre-drill holes in your window frame.</h3>
	<p>
		Install one frame clip on each side, typically ⅔ up from the bottom of the
		window sill and ¼” from the edge of the frame. Pre-drilling a 1/16” hole
		prior to installation of the frame clip will ensure your wood does not
		split.
	</p>

	<h3>For drafty windows, install another on each side.</h3>
	<p>
		If you have drafty windows that let in a lot of air, install another pair of
		frame clips 1/3 up from the bottom. Often, one frame clip on the top of the
		window or one on each side is adequate.
	</p>
</Section>

<Section>
	<h2>How to Install Retaining Pins</h2>
	<p>
		Retaining pins can be installed in front of the Indow insert to hold it
		securely in place. This works great with deeper window wells or situations
		where the swivel clip does not work.
	</p>

	<Image src={retainingPins} class="w-auto" />

	<h3>Pre-drill holes in your window frame.</h3>
	<p>
		Use a 5/64″ or 3/32″ drill bit to pre-drill holes for 1-2 retaining pins on
		each side of your window, typically ⅓ of the way down from the top, right in
		front of where your Indow insert will be installed. Make sure that the
		retaining pin will not be pressing into your compression tubing, which could
		cause damage.
	</p>
	<h3>For drafty windows, install another on each side.</h3>
	<p>
		If you have drafty windows that let in a lot of air, install another pair of
		retaining pins 1/3 up from the bottom. Often, one pin on the top of the
		window or one on each side is adequate.
	</p>
</Section>

<Location />
